import React, { Component, Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';
import Loadable from 'react-loadable';

import '../../node_modules/font-awesome/scss/font-awesome.scss';

import Loader from './layout/Loader'
import Aux from "../hoc/_Aux";
import ScrollToTop from './layout/ScrollToTop';
import routes from "../route";
import ProtectedRoute from "../common/protectedRoute";

import {connect} from 'react-redux';
import { HANDLE_COMMON } from "../store/actions";

import Api from "../common/api";
import ApiUrl from "../common/apiUrl";

const AdminLayout = Loadable({
    loader: () => import('./layout/AdminLayout'),
    loading: Loader
});

class App extends Component {

    // componentDidMount = () => {
    //     this.getUserDetail();
    // }

    render() {
        const menu = routes.map((route, index) => {
            if(route.path === "/information" || route.path === "/information-report"){
                if(!(this.props.userDetail && this.props.userDetail.isinformation)){
                    return null;
                }
            }
            if(route.path === "/follow-up" || route.path === "/followup-report"){
                if(!(this.props.userDetail && this.props.userDetail.isfollowup)){
                    return null;
                }
            }
            return (route.component) ? (
                <Route
                    key={index}
                    path={route.path}
                    exact={route.exact}
                    name={route.name}
                    render={props => (
                        <route.component {...props} />
                    )} />
            ) : (null);
        });

        return (
            <Aux>
                <ScrollToTop>
                    <Suspense fallback={<Loader/>}>
                        <Switch>
                            {menu}
                            <ProtectedRoute path="/" component={AdminLayout} />
                        </Switch>
                    </Suspense>
                </ScrollToTop>
            </Aux>
        );
    }
}

export default App;

// const mapStateToProps = ({
//     common: {
//         userDetail
//     }
// }) => ({
//     userDetail
// });

// const mapDispatchToProps = dispatch => {
//     return {
//         handleCommon: (data) => dispatch({type: HANDLE_COMMON, data }),
//     }
// };

// export default connect(mapStateToProps, mapDispatchToProps)(App);
